import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography,
  TextField,
  Select,
  MenuItem,
  FormControl,
  Box,
  IconButton,
  InputAdornment,
  Avatar,
  Tooltip,
  Menu as MenuComponent,
  ListItemIcon,
  Popover,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Divider
} from '@mui/material';
import {
  Person,
  Logout,
  People as PeopleIcon,
  Key as KeyIcon,
  Settings as SettingsIcon,
  ChevronRight as ChevronRightIcon,
  CorporateFare as CorporateFareIcon,
  ElectricBolt as ElectricBoltIcon,
  NewReleases as NewReleasesIcon,
  MenuOpen as MenuOpenIcon,
  Close as CloseIcon,
  AccountBalanceWallet as AccountBalanceWalletIcon,
  Search as SearchIcon,
  ExpandMore,
  ExpandLess,
  Bolt as BoltIcon,
  Label as LabelIcon,
  BugReport as BugReportIcon,
  FeedbackOutlined,

} from "@mui/icons-material";
import { Icon } from "@iconify/react";
import { useGetAllPermissions } from '../pages/utils/getAllPermissions';
import CURRENCIES from '../components/Navbar/currencies';
import { getAvatarUrl } from "../pages/utils/avatarCache";
import api from '../api';
import BubbleLoader from './BubbleLoader';

import { toast } from 'sonner';
import FeedbackForm from './FeedbackForm';
import Cookies from 'js-cookie';


const Navbar = ({
  title,
  searchOptions = [],
  onSearchOptionChange = () => { },
  onSearchValueChange = () => { },
  searchOption = '',
  searchValue = '',
  showReleaseButton = false,
}) => {

  const { permissions, getAllPermissions } = useGetAllPermissions();
  const userRole = localStorage.getItem("Role");
  const user = JSON.parse(localStorage.getItem("User"));
  const [menuOpen, setMenuOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState('');
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const [organizationAnchorEl, setOrganizationAnchorEl] = useState(null);
  // — fetched release logs
  const [releaseLogs, setReleaseLogs] = useState([]);
  // — popover anchor + open state
  const [releaseAnchor, setReleaseAnchor] = useState(null);
  const [loading, setLoading] = useState(true);
  const releaseOpen = Boolean(releaseAnchor);
  const [feedbackDialogOpen, setFeedbackDialogOpen] = useState(false);

  const isOrganizationMenuOpen = Boolean(organizationAnchorEl);
  const canManageBilling = permissions?.includes("manage_billing") ?? false;
  const canManageMembers = permissions?.includes("manage_members") ?? false;
  const canManageApiKeys = permissions?.includes("manage_api_keys") ?? false;
  const hasOrgSettings = canManageMembers || canManageApiKeys || canManageBilling;
  const id = localStorage.getItem("Organization");

  const handleReleaseOpen = e => setReleaseAnchor(e.currentTarget);
  const handleReleaseClose = () => setReleaseAnchor(null);

  const handleOrganizationSettingsClick = (event) => {
    setOrganizationAnchorEl(event.currentTarget);
  };

  const handleFeedbackSubmit = async (data) => {
    const response = await api.post('/v1/feedback', data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    // const dataRes = await response.data;
    toast.success(response.data.message);
  };

  const handleOrganizationSettingsClose = () => {
    setOrganizationAnchorEl(null);
  };

  const [token, setToken] = useState(() => {
    const tokenData = localStorage.getItem("token");
    return tokenData ? JSON.parse(tokenData).token : null;
  });

  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    return localStorage.getItem('sidebarOpen') === 'true';
  });

  const handleOpenFeedbackDialog = () => {
    setFeedbackDialogOpen(true); // This state should control your modal visibility
  };
  const renderOrganizationSettingsMenu = () => (

    hasOrgSettings && (
      <Popover
        anchorEl={organizationAnchorEl}
        open={isOrganizationMenuOpen}
        onClose={handleOrganizationSettingsClose}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        PaperProps={{
          sx: {
            borderRadius: '14px',
            boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
            width: '250px',
            mt: 1,
            ml: -2 // Negative margin to move it more to the left
          }
        }}
      >
        <Box sx={{ p: 1 }}>

          {canManageMembers && (
            <MenuItem
              sx={{
                borderRadius: '7px',
                p: 1,
                gap: 1,
                '&:hover': {
                  bgcolor: 'action.hover',
                  '& .MuiListItemIcon-root': {
                    color: '#02042D',
                  }
                }
              }}
              component={Link}
              to={`/company/${id}/member`}
            >
              <ListItemIcon>
                <PeopleIcon sx={{ fontSize: 18 }} />
              </ListItemIcon>
              <Typography sx={{ fontWeight: 500 }}>Members</Typography>
            </MenuItem>
          )}

          {canManageApiKeys && (
            <MenuItem
              sx={{
                borderRadius: '7px',
                p: 1,
                gap: 1,
                '&:hover': {
                  bgcolor: 'action.hover',
                  '& .MuiListItemIcon-root': {
                    color: '#02042D',
                  }
                }
              }}
              component={Link}
              to="/api-key-management"
            >
              <ListItemIcon>
                <KeyIcon sx={{ fontSize: 18 }} />
              </ListItemIcon>
              <Typography sx={{ fontWeight: 500 }}>API Keys</Typography>
            </MenuItem>
          )}

          {canManageBilling && (
            <>
              <MenuItem
                sx={{
                  borderRadius: '7px',
                  p: 1,
                  gap: 1,
                  '&:hover': {
                    bgcolor: 'action.hover',
                    '& .MuiListItemIcon-root': {
                      color: '#02042D',
                    }
                  }
                }}
                component={Link}
                to={`/manage-billing`}
              >
                <ListItemIcon>
                  <ElectricBoltIcon sx={{ fontSize: 18 }} />
                </ListItemIcon>
                <Typography sx={{ fontWeight: 500 }}>Upgrade Plan</Typography>
              </MenuItem>
              <MenuItem
                disabled
                sx={{
                  m: 0.4,
                  borderRadius: '7px',
                  p: 1, // Reduced padding
                  gap: 0.5,
                  opacity: 0.6, // Reduce opacity to indicate it's disabled
                  cursor: "not-allowed", // Show 'not allowed' cursor
                  bgcolor: "action.disabledBackground", // Use a disabled background color
                  '& .MuiListItemIcon-root': {
                    color: 'action.disabled', // Faded icon color
                  }
                }}
                component={Link}
              >
                <ListItemIcon>
                  <SettingsIcon sx={{ fontSize: 18 }} />
                </ListItemIcon>
                <Box display="flex" flexDirection="column">
                  <Typography sx={{ fontWeight: 500 }}>Settings</Typography>
                </Box>
              </MenuItem>
              <MenuItem
                disabled
                sx={{
                  m: 0.4,
                  borderRadius: '7px',
                  p: 1, // Reduced padding
                  gap: 0.5,
                  opacity: 0.6, // Reduce opacity to indicate it's disabled
                  cursor: "not-allowed", // Show 'not allowed' cursor
                  bgcolor: "action.disabledBackground", // Use a disabled background color
                  '& .MuiListItemIcon-root': {
                    color: 'action.disabled', // Faded icon color
                  }
                }}
                component={Link}
              >
                <ListItemIcon>
                  <AccountBalanceWalletIcon sx={{ fontSize: 18 }} />
                </ListItemIcon>
                <Box display="flex" flexDirection="column">
                  <Typography sx={{ fontWeight: 500 }}>Get Minutes</Typography>
                </Box>
              </MenuItem>
            </>
          )}
        </Box>
      </Popover>
    )
  );

  // — fetch releases when button is enabled
  useEffect(() => {
    if (!showReleaseButton) return;
    (async () => {
      try {
        const res = await api.get('/v1/release-logs/all', {
          headers: { Authorization: `Bearer ${token}` }
        });
        setReleaseLogs(res.data.data || []);
      } catch (err) {
        console.error('Failed to load release logs', err);
      } finally {
        setLoading(false);
      }
    })();
  }, [showReleaseButton, token]);

  useEffect(() => {
    getAllPermissions();
  }, [token, getAllPermissions]);

  const handleGetAvatarUrl = () => {
    return getAvatarUrl(user);
  };

  useEffect(() => {
    setImageUrl(handleGetAvatarUrl());

    const handleStorageChange = () => {
      setImageUrl(handleGetAvatarUrl());
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [user?.ProfilePicture]);

  const handleLogout = () => {
    setMenuOpen((prev) => !prev);
    localStorage.clear();
    sessionStorage.clear();
    Cookies.set("maintenance_routes",[]); 
    document.cookie.split(';').forEach(cookie => {
      const cookieName = cookie.split('=')[0].trim();
      document.cookie = `${cookieName}=; path=/; domain=.liaplus.com; expires=Thu, 01 Jan 1970 00:00:00 UTC; secure; samesite=None`;
    });
  
    window.location.href = "/login";
    setTimeout(() => {
      setToken(null);
    }, 0);
  };
  

  const handleLogoutClick = () => {
    setLogoutDialogOpen(true);
    handleProfileClose();
  };

  const handleLogoutCancel = () => {
    setLogoutDialogOpen(false);
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleProfileClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleProfileClose = () => {
    setAnchorEl(null);
  };

  const [currency, setCurrency] = useState(() => {
    const savedCurrency = localStorage.getItem('currency');
    return savedCurrency || 'USD';
  });

  const handleCurrencyChange = (event) => {
    const newCurrency = event.target.value;
    setCurrency(newCurrency);
    localStorage.setItem('currency', newCurrency);
  };

  const toggleSidebar = () => {
    const newState = !isSidebarOpen;
    setIsSidebarOpen(newState);
    localStorage.setItem('sidebarOpen', newState);
  };

  useEffect(() => {
    const savedState = localStorage.getItem('sidebarOpen') === 'true';
    if (savedState !== isSidebarOpen) {
      setIsSidebarOpen(savedState);
    }

    const handleStorageChange = (e) => {
      if (e.key === 'sidebarOpen') {
        setIsSidebarOpen(e.newValue === 'true');
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [isSidebarOpen]);


  return (
    <AppBar
      position="static"
      className='appBar'
      sx={{
        boxShadow: 0,
        borderBottom: "1px solid #F0F0F0",
        bgcolor: 'white'
      }}
    >
      <Toolbar className='toolBar' sx={{ minHeight: { xs: '64px', sm: '70px' } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', columnGap: '0.8rem', flexGrow: 1 }}>
          <Tooltip title={isSidebarOpen ? "Collapse Sidebar" : "Expand Sidebar"} arrow>
            <IconButton
              size="large"
              edge="start"
              aria-label={isSidebarOpen ? "Collapse Sidebar" : "Expand Sidebar"}
              onClick={toggleSidebar}
              sx={{
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                  bgcolor: 'rgba(0, 0, 0, 0.04)',
                  transform: 'scale(1.05)'
                }
              }}
            >
              <MenuOpenIcon
                style={{
                  color: 'black',
                  fontSize: '24px',
                  transform: isSidebarOpen ? 'rotate(0deg)' : 'rotate(180deg)',
                  transition: 'transform 0.3s ease-out'
                }}
              />
            </IconButton>
          </Tooltip>
          <Typography
            variant='h5'
            color="text.primary"
            sx={{
              fontWeight: 600,
              letterSpacing: '-0.5px'
            }}
          >
            {title}
          </Typography>
        </Box>

        {showReleaseButton && (
          <>
            <Button
              variant="outlined"
              size="medium"
              onClick={handleReleaseOpen}
              startIcon={!loading && <Icon icon="ph:scroll" width="20" height="20" />}
              endIcon={!loading && (releaseOpen ? <ExpandLess /> : <ExpandMore />)}
              sx={{
                textTransform: 'none',
                borderRadius: 2,
                borderColor: 'divider',
                color: 'text.primary',
                bgcolor: 'background.paper',
                px: 2,
                fontWeight: 500,
                minWidth: 120,
                '&:hover': { bgcolor: 'action.hover' },
                // ensure button is tall enough for the loader
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              {loading ? (
                  <BubbleLoader />
              ) : (
                releaseLogs[0]?.version ?? 'No updates'
              )}
            </Button>

            <Popover
              anchorEl={releaseAnchor}
              open={releaseOpen}
              onClose={handleReleaseClose}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              PaperProps={{
                elevation: 4,
                sx: {
                  mt: 1.5,
                  px: 1.5,
                  py: 1.5,
                  width: 300,
                  borderRadius: 2,
                  maxHeight: 400,
                  overflowY: 'auto',
                },
              }}
            >
              {releaseLogs.slice(0, 3).map((release, idx) => {
                const { version, date, title, client_updates:changes } = release;
                const highlights = [
                  changes.features?.[0] && { type: 'features', text: changes.features[0] },
                  changes.improvements?.[0] && { type: 'improvements', text: changes.improvements[0] },
                  changes.bug_fixes?.[0] && { type: 'bug_fixes', text: changes.bug_fixes[0] },
                ].filter(Boolean);

                const iconMap = {
                  features: { icon: BoltIcon, color: 'success.main' },
                  improvements: { icon: LabelIcon, color: 'warning.main' },
                  bug_fixes: { icon: BugReportIcon, color: 'error.main' },
                };

                return (
                  <Box
                    key={version}
                    component={Link}
                    to="/release-logs"
                    onClick={handleReleaseClose}
                    sx={{
                      display: 'block',
                      textDecoration: 'none',
                      borderRadius: 2,
                      p: 1.25,
                      mb: 1.25,
                      transition: 'background 0.2s',
                      '&:hover': { bgcolor: 'action.hover' },
                    }}
                  >
                    {/* Version and date */}
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                      <Typography fontWeight={600} fontSize="0.95rem">{version}</Typography>
                      <Typography fontSize="0.75rem" color="text.secondary">
                        {new Date(date).toLocaleDateString()}
                      </Typography>
                    </Box>

                    {/* Title */}
                    {title && (
                      <Typography
                        variant="body2"
                        fontWeight={500}
                        sx={{
                          mb: 1,
                          color: 'text.primary',
                          fontSize: '0.85rem',
                        }}
                      >
                        {title}
                      </Typography>
                    )}

                    {/* Highlights */}
                    {highlights.map(({ type, text }, i) => {
                      const { icon: IconComp, color } = iconMap[type];
                      return (
                        <Box
                          key={i}
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            mb: i < highlights.length - 1 ? 0.5 : 0,
                          }}
                        >
                          <IconComp sx={{ fontSize: 16, color, mr: 1 }} />
                          <Typography
                            variant="body2"
                            sx={{
                              fontSize: '0.85rem',
                              color: 'text.secondary',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            }}
                          >
                            {text}
                          </Typography>
                        </Box>
                      );
                    })}
                  </Box>
                );
              })}

              <Divider sx={{ my: 0.5 }} />
              <MenuItem
                component={Link}
                to="/release-logs"
                onClick={handleReleaseClose}
                sx={{
                  textAlign: 'center',
                  fontWeight: 600,
                  fontSize: '0.9rem',
                  color: '#02042D',
                  borderRadius: 1,
                  py: 1,
                  justifyContent: 'center',
                  '&:hover': { bgcolor: 'action.hover' },
                }}
              >
                View All Releases
              </MenuItem>
            </Popover>
          </>
        )}






        {searchOptions.length > 0 && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexGrow: 1,
              justifyContent: 'flex-end',
              maxWidth: '400px',
              borderRadius: '12px',
              border: '1px solid #E5E7EB',
              backgroundColor: '#FFFFFF',
            }}
          >
            <FormControl variant="standard" size="small">
              <Select
                value={searchOption}
                onChange={onSearchOptionChange}
                displayEmpty
                sx={{
                  '& .MuiSelect-select': {
                    paddingY: '10px',
                    paddingLeft: '16px',
                    paddingRight: '32px',
                    fontWeight: 300,
                    color: '#374151',
                  },
                  '&:before, &:after': { display: 'none' },
                }}
              >
                <MenuItem value="All">
                  <Typography sx={{ fontWeight: 500 }}>All</Typography>
                </MenuItem>
                {searchOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    <Typography sx={{ fontWeight: 500 }}>{option.label}</Typography>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Box
              sx={{
                height: '24px',
                width: '1px',
                backgroundColor: '#E5E7EB',
                margin: '0 8px',
              }}
            />
            <TextField
              variant="standard"
              placeholder="Search..."
              value={searchValue}
              onChange={onSearchValueChange}
              InputProps={{
                disableUnderline: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <SearchIcon sx={{ color: '#9CA3AF', marginRight: '12px' }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                flexGrow: 1,
                '& .MuiInputBase-root': {
                  padding: '8px 12px',
                },
                '& .MuiInputBase-input': {
                  color: '#374151',
                  '&::placeholder': {
                    color: '#9CA3AF',
                    opacity: 1,
                  },
                },
              }}
            />
          </Box>
        )}
   <Button
          onClick={handleOpenFeedbackDialog}
          variant="outlined"
          startIcon={
            <FeedbackOutlined sx={{ fontSize: { xs: '18px', sm: '22px' } }} />
          }
          sx={{
            textTransform: 'none',
            borderRadius: '8px',
            ml: 1,
            fontWeight: 500,
            fontSize: {
              xs: '0.75rem', // smaller font on small screens
              sm: '0.875rem', // normal font on medium and up
            },
            px: {
              xs: 1.5, // smaller horizontal padding on small screens
              sm: 2, // normal padding otherwise
            },
            py: {
              xs: 0.5, // smaller vertical padding
              sm: 1,
            },
            color: '#374151',
            borderColor: '#E5E7EB',
            backgroundColor: '#fff',
            '&:hover': {
              backgroundColor: '#F9FAFB',
              borderColor: '#CBD5E1',
            },
          }}
        >
          Feedback
        </Button>
        <FeedbackForm
          open={feedbackDialogOpen}
          onClose={() => setFeedbackDialogOpen(false)}
          onSubmit={handleFeedbackSubmit}
        />

        <Box sx={{ ml: 2, display: 'flex', alignItems: 'center' }}>
          <Tooltip title="Account settings" arrow >
            <IconButton
              onClick={handleProfileClick}
              size="small"
              sx={{
                ml: 2,
                p: '8px',
                borderRadius: '8px',
                border: '1px solid',
                borderColor: '#dadce0',
                backgroundColor: 'rgba(255,255,255,.88)',
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                  backgroundColor: 'rgba(244, 244, 244, 0.06)',
                  borderColor: 'rgb(211, 233, 250)',
                  transform: 'translateY(-1px)'
                }
              }}
              aria-controls={open ? 'account-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Avatar
                  sx={{
                    width: 38,
                    height: 38,
                    bgcolor: 'transparent',
                    border: '2px solid transparent',
                    transition: 'all 0.2s ease-in-out',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                    '&:hover': {
                      borderColor: '#E5E7EB',
                      transform: 'scale(1.02)',
                    },
                  }}
                >
                  <img
                    src={imageUrl}
                    alt="Profile"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      borderRadius: '50%',
                    }}
                  />
                </Avatar>
                <Box sx={{
                  display: { xs: 'none', sm: 'block' },
                  textAlign: 'left'
                }}>
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: '0.95rem',
                      lineHeight: 1.2,
                      color: 'text.primary'
                    }}
                  >
                    {user?.Name?.length > 12 ? `${user?.Name.slice(0, 10)}...` : user?.Name}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '0.75rem',
                      color: 'text.secondary',
                      lineHeight: 1.2
                    }}
                  >
                    {userRole ? `${userRole}` : ""}
                  </Typography>
                </Box>
              </Box>
            </IconButton>
          </Tooltip>
        </Box>

        <MenuComponent
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleProfileClose}
          PaperProps={{
            elevation: 3,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 4px 12px rgba(0,0,0,0.1))',
              mt: 1.2,
              borderRadius: '14px',
              minWidth: '200px',
              '& .MuiList-root': {
                padding: '6px'
              },
              '&:before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 18,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },

            },
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <Box
            sx={{
              p: 2,
              pb: 1.8,
              borderBottom: '1px solid',
              borderColor: 'divider',
              bgcolor: 'rgba(0, 0, 0, 0.01)'
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <Avatar
                sx={{
                  width: 40,
                  height: 40,
                  bgcolor: 'transparent',
                  border: '2px solid',
                  borderColor: '#E5E7EB',
                }}
              >
                <img
                  src={imageUrl}
                  alt="Profile"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    borderRadius: '50%',
                  }}
                />
              </Avatar>
              <Box>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 600,
                    color: 'text.primary',
                    lineHeight: 1.2,
                  }}
                >
                  {user?.Name?.length > 12 ? `${user?.Name.slice(0, 10)}...` : user?.Name}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: 'text.secondary',
                    fontSize: '0.8rem'
                  }}
                >
                  {`${user?.Email?.length > 12 ? `${user?.Email.slice(0, 18)}...` : user?.Email}`}
                </Typography>
              </Box>
            </Box>
          </Box>
          <MenuItem
            component={Link}
            to="/profile"
            sx={{
              m: 0.4,
              borderRadius: '7px',
              p: 1,
              gap: 0.5,
              '&:hover': {
                bgcolor: 'action.hover',
                '& .MuiListItemIcon-root': {
                  color: '#02042D',
                  transform: 'scale(1.08)'
                }
              }
            }}>
            <ListItemIcon>
              <Person sx={{ fontSize: 18 }} />
            </ListItemIcon>
            <Typography sx={{ fontWeight: 500 }}>View Profile</Typography>
          </MenuItem>

          <MenuItem
            onClick={handleOrganizationSettingsClick}
            sx={{
              m: 0.4,
              borderRadius: '7px',
              p: 1,
              gap: 0.5,
              '&:hover': {
                bgcolor: 'action.hover',
                '& .MuiListItemIcon-root': {
                  color: '#02042D',
                  transform: 'scale(1.08)'
                }
              }
            }}
          >
            <ListItemIcon>
              <CorporateFareIcon sx={{ fontSize: 18 }} />
            </ListItemIcon>
            <Typography sx={{ fontWeight: 500 }}>Organization</Typography>
            <ChevronRightIcon sx={{ ml: 'auto', fontSize: 18 }} />
          </MenuItem>

          <MenuItem
            component={Link}
            disabled
            sx={{
              m: 0.4,
              borderRadius: '7px',
              p: 1,
              gap: 0.5,
              opacity: 0.6,
              cursor: "not-allowed",
              bgcolor: "action.disabledBackground",
              '& .MuiListItemIcon-root': {
                color: 'action.disabled',
              }
            }}
          >
            <ListItemIcon>
              <NewReleasesIcon sx={{ fontSize: 18 }} />
            </ListItemIcon>
            <Box display="flex" flexDirection="column">
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%'
              }}>
                <Typography sx={{ fontWeight: 500 }}>Currency</Typography>
                <Select
                  value={currency}
                  onChange={handleCurrencyChange}
                  size="small"
                  sx={{
                    ml: 2,
                    '.MuiSelect-select': {
                      py: 0.5,
                      pl: 1.5,
                      pr: 3,
                      fontSize: '0.875rem',
                      fontWeight: 500
                    },
                    '.MuiOutlinedInput-notchedOutline': {
                      borderColor: 'divider'
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#02042D'
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#02042D'
                    }
                  }}
                >
                  {Object.values(CURRENCIES).map((curr) => (
                    <MenuItem key={curr.code} value={curr.code}>
                      {curr.label}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
              <Typography variant="caption" color="text.secondary">
                Coming Soon
              </Typography>
            </Box>
          </MenuItem>

          <Box sx={{ px: 0.4, pb: 0.4 }}>
            <MenuItem
              sx={{
                borderRadius: '7px',
                p: 1.2,
                mt: 1,
                gap: 1.2,
                color: 'error.main',
                borderTop: '1px solid',
                borderColor: 'divider',
                '&:hover': {
                  bgcolor: 'error.lighter',
                  '& .MuiListItemIcon-root': {
                    transform: 'scale(1.08)'
                  }
                }
              }}
              onClick={handleLogoutClick}
            >
              <ListItemIcon>
                <Logout sx={{ fontSize: 18 }} />
              </ListItemIcon>
              <Typography sx={{ fontWeight: 500 }}>Sign Out</Typography>
            </MenuItem>
          </Box>

        </MenuComponent>

      </Toolbar>

      {renderOrganizationSettingsMenu()}

      <Dialog
        open={logoutDialogOpen}
        onClose={handleLogoutCancel}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            p: 1,
          }
        }}
      >
        <IconButton
          aria-label="close"
          onClick={handleLogoutCancel}
          sx={{
            position: 'absolute',
            right: 16,
            top: 16,
            color: 'grey.500',
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogTitle sx={{ pb: 1, pt: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1 }}>
            <Typography variant="h5" component="span" fontWeight={600}>
              Sign Out
            </Typography>
          </Box>
        </DialogTitle>

        <DialogContent>
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ fontWeight: 500 }}
          >
            Are you sure you want to sign out? Any unsaved changes will be lost.
          </Typography>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
          <Button
            onClick={handleLogoutCancel}
            variant="outlined"
            sx={{
              borderRadius: 2,
              px: 3,
              py: 1,
              textTransform: 'none',
              fontWeight: 600,
              borderColor: 'grey.300',
              color: 'text.primary',
              '&:hover': {
                borderColor: 'grey.400',
                backgroundColor: 'grey.50',
              }
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleLogout}
            variant="contained"
            color="error"
            sx={{
              borderRadius: 2,
              px: 3,
              py: 1,
              textTransform: 'none',
              fontWeight: 600,
              boxShadow: 'none',
              '&:hover': {
                boxShadow: 'none',
                backgroundColor: 'error.dark',
              }
            }}
          >
            Sign Out
          </Button>
        </DialogActions>
      </Dialog>

    </AppBar>
  );
};

export default Navbar;